export const BDC_TITRE_BDC = 'BON DE COMMANDE';
export const BDC_TITRE_DEVIS = 'DEVIS';

export const DEFAULT_BDC_OPTIONS = {
  document_titre: BDC_TITRE_BDC,
  mode_reglement: 'Prélèvement bancaire',
  facturation: '100% à la commande',
  conditions_reglement: 'Selon échéancier de prélèvement',
};

export const BDC_TITRE_OPTIONS = [BDC_TITRE_BDC, BDC_TITRE_DEVIS];

export const BDC_MODE_REGLEMENT_OPTIONS = [
  'Prélèvement bancaire',
  'Chèque',
  'Virement bancaire',
  'Carte bancaire',
  'Espèces',
];

/** Libellés = valeurs exactes du select Facturation Dolibarr. */
export const BDC_FACTURATION_OPTIONS = [
  '100% à la commande',
  '50% à la commande / 25% à 30 jours / 25% à 60 jours',
  '50% à la commande / puis facturation à l\'avancement',
  'Pas d\'acompte',
  'Acompte spécifique',
];

export const BDC_CONDITIONS_REGLEMENT_OPTIONS = [
  'Selon échéancier de prélèvement',
  'A réception de facture (le lendemain)',
  '30 jours fin de mois',
  '30 jours fermes',
  '45 jours fin de mois le 10 (voir avec Direction)',
  'Conditions spécifiques de règlement (accord Direction, les conditions sont écrites en fin de devis)',
];

export function resolveBdcOptionsFromMeta(meta) {
  const source = meta?.bdc_options;
  if (!source) {
    return {
      defaults: { ...DEFAULT_BDC_OPTIONS },
      titres: BDC_TITRE_OPTIONS,
      modes_reglement: BDC_MODE_REGLEMENT_OPTIONS,
      facturations: BDC_FACTURATION_OPTIONS,
      conditions_reglement: BDC_CONDITIONS_REGLEMENT_OPTIONS,
    };
  }

  return {
    defaults: { ...DEFAULT_BDC_OPTIONS, ...(source.defaults ?? {}) },
    titres: source.titres?.length ? source.titres : BDC_TITRE_OPTIONS,
    modes_reglement: source.modes_reglement?.length ? source.modes_reglement : BDC_MODE_REGLEMENT_OPTIONS,
    facturations: source.facturations?.length ? source.facturations : BDC_FACTURATION_OPTIONS,
    conditions_reglement: source.conditions_reglement?.length
      ? source.conditions_reglement
      : BDC_CONDITIONS_REGLEMENT_OPTIONS,
  };
}

const MOIS_LABELS = [
  'JANVIER', 'FEVRIER', 'MARS', 'AVRIL', 'MAI', 'JUIN',
  'JUILLET', 'AOUT', 'SEPTEMBRE', 'OCTOBRE', 'NOVEMBRE', 'DECEMBRE',
];

function collectPlanDeComYears(lignes = [], fallbackStart = null, fallbackEnd = null) {
  const years = new Set();
  const rows = [...(lignes ?? [])].sort((a, b) => (Number(a?.ordre) || 0) - (Number(b?.ordre) || 0));
  const first = rows[0];
  const firstMonthIndex = first
    ? MOIS_LABELS.indexOf(String(first.mois ?? '').trim().toUpperCase())
    : -1;
  const firstYear = Number(first?.annee) || 0;

  rows.forEach((ligne, index) => {
    const year = Number(ligne?.annee);
    if (Number.isFinite(year) && year > 0) {
      years.add(year);
    }
    if (firstMonthIndex >= 0 && firstYear > 0) {
      years.add(firstYear + Math.floor((firstMonthIndex + index) / 12));
    }
  });

  const start = Number(fallbackStart) || 0;
  const end = Number(fallbackEnd) || 0;
  if (start > 0) years.add(start);
  if (end > 0) years.add(end);

  return [...years].filter((year) => Number.isFinite(year) && year > 0).sort((a, b) => a - b);
}

export function formatPlanDeComPeriode(lignes = [], fallbackStart = null, fallbackEnd = null) {
  const years = collectPlanDeComYears(lignes, fallbackStart, fallbackEnd);
  if (years.length === 0) {
    return String(new Date().getFullYear());
  }
  if (years.length === 1) {
    return String(years[0]);
  }
  return `${years[0]}-${years[years.length - 1]}`;
}
